/*eslint-disable*/
import React, { useState, useRef, useEffect } from "react";

// reactstrap components
import {
    Container,
} from "reactstrap";

// core components
import WhiteNavbar from "../../components/Navbars/WhiteNavbar";
import { useParams } from "react-router-dom"
import EventImageLeft from "../../components/Portfolio/EventCategoryPage/EventImageLeft"
import EventImageRight from "../../components/Portfolio/EventCategoryPage/EventImageRight"
import { Helmet } from "react-helmet"
import { LoadingScreen, RouteHome } from "../../components/MiscFunctions"
import { Fragment } from "react";
import EventCarouselItem from "components/Portfolio/Index/EventCarouselItem";
import styled from "styled-components"
import { Controller, Scene } from "react-scrollmagic"

// Parallax
const SectionWipesStyled = styled.div`
  overflow: hidden;

  .panel {
    height: 100vh;
    width: 100vw;
  }
`;


function EventCategoryPage(props) {

    document.documentElement.classList.remove("nav-open");

    const { name } = useParams()

    // makes the event alternate
    const index = useRef(-1)

    const [events] = useState(props.location?.state?.events)
    const [eventCategory] = useState(props.location?.state?.category)

    return (
        <div>
            <Helmet>
                <title>{name} - Smart Event and Production Qatar's Best Event Manager </title>
                <meta name="description" content="Smart Event and Production  Events" />
                <meta name="robots" content="index, follow" />
                <meta name="og:title" content="Smart Event and Production - Qatar's Best Event Manager." />
                <meta name="og:description" content="Smart Event and Production offers services ranging from
                    Wedding events, Birthday events, Sports events, Public Events, Conferences, and many more!"
                />
            </Helmet>
            {
                eventCategory ?
                    <Fragment>
                        <WhiteNavbar />
                        <SectionWipesStyled>
                            <Controller globalSceneOptions={{ triggerHook: 'onLeave' }}>
                                <Scene pin>
                                    <div className="panel">
                                        <EventCarouselItem {...eventCategory} />
                                    </div>
                                </Scene>
                            </Controller>
                        </SectionWipesStyled>
                        <div className="project-4 section section-dark fullBg flex-centered">
                            <Container style={{ minWidth: "90%" }}>
                                {
                                    events?.map((event) => {
                                        index.current++
                                        return index.current % 2 === 0
                                            ?
                                            <EventImageLeft {...event} key={event.id} />
                                            :
                                            <EventImageRight {...event} key={event.id} />
                                    })
                                }
                            </Container>
                        </div>
                    </Fragment>
                    :
                    props.location.state || events || eventCategory
                        ?
                        <LoadingScreen />
                        :
                        <RouteHome />
            }
        </div>
    );
}

export default EventCategoryPage;